export default __webpack_public_path__ + "static/media/search.acef3b8c.svg";